function theSameHeight($className) {
    $($className).css('height','auto');
    var heights = $($className).map(function() {
        return $(this).height();
    }).get();

    var maxHeight = Math.max.apply(null, heights);

    $($className).height(maxHeight);

};

theSameHeight('.sameHeight');